import { render, staticRenderFns } from "./ProviderList.vue?vue&type=template&id=05ac0c8a"
import script from "./ProviderList.js?vue&type=script&lang=js&external"
export * from "./ProviderList.js?vue&type=script&lang=js&external"
import style0 from "./ProviderList.vue?vue&type=style&index=0&id=05ac0c8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports